<template>
    <div>
        <form>
            <div class="row project-cards">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>Documentos</h3>
                                    <br />
                                </div>
                                <div class="col-lg-4 col-md-6" v-for="(document,index) in document_types" :key="index" >
                                    <div class="project-box">
                                        <h6>{{ document.name }}</h6>
                                        <div class="d-flex mb-3">
                                            <div class="flex-grow-1 project-box-item">
                                                <p>{{ documents[document] ? "Cargado" : "Pendiente" }}</p>
                                            </div>
                                        </div>
                                        <button v-if="documents[document.code]" class="btn btn-xs btn-primary" @click="uploadModal(employee, document.code)" type="button" style="float: right; margin-left: 15px;" title="btn btn-success btn-sm"  data-bs-toggle="modal" data-bs-target=".employee-upload-modal">Volver a Cargar</button>
                                        <button v-if="!documents[document.code]" class="btn btn-xs btn-primary" @click="uploadModal(employee, document.code)" type="button" style="float: right; margin-left: 15px;" title="btn btn-success btn-sm"  data-bs-toggle="modal" data-bs-target=".employee-upload-modal">Cargar</button>
                                        <a v-if="documents[document.code]" class="btn btn-info btn-xs" :href="documents[document.code] ? documents[document.code].document_url : '#'" target="_blank" style="float: right; margin-right: 10px;" >Descargar</a>
                                        <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="modal fade employee-upload-modal" tabindex="-1" role="dialog" aria-labelledby="employeeUploadModalLabel" aria-hidden="true">
            <EmployeeUploadModal ref="employeeUploadModal" />
        </div>
    </div>
</template>
<script>

import validations from "@/mixins/validations/employeeValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

import EmployeeUploadModal from "@/components/tmkt/employees/employees_upload_modal.vue";

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import ws from '@/services/employees'

export default {
    name: 'employee_documents_tab',
    mixins: [validations, modalCleanupMixin],
    components: {
        Datepicker,
        EmployeeUploadModal
    },
    data(){
        return{
            employee: null,
            token: '',
            document_types: [
                {code: 'personal', name: 'Identificación oficial (INE o pasaporte)'},     
                {code: 'address', name: 'Comprobante de domicilio (no mayor a 3 meses)'},
                {code: 'fiscal', name: 'Comprobane de Situación Fiscal (CIF o CSF)'}, 
                {code: 'imss', name: 'Vigencia de derechos (IMSS) o Numero del seguro social'},
                {code: 'bank', name: 'Carátula de estado de cuenta bancario (BBVA)'}, 
                {code: 'infonavit', name: 'Hoja de retencion del Credito Infonavit o Fonacot'}
            ],
            documents: []
        }
    },
    methods: {
        async loadEmployee(employee){
            this.employee = employee;

            let response = await ws.getDocuments(employee.id);

            if(response.type == "success"){
                this.closeModal();

                this.documents = response.data;
            }

            this.setForm(this.employee);
        },
        uploadModal(type){
            this.$refs.employeeUploadModal.loadEmployee(this.employee, type);
        }
    }
}
</script>
<style>
    .dp1{
        input {
            height: 24px;
        }
    }
</style>